import { useCallback } from 'react';
import { type CompanyOption, selectedCompany } from '../../types/registration';

// A company picked from the searchable select has an id; the sentinel 0 means
// "not in the list", i.e. a brand-new company.
const useIsExistingCompany = (fields: {
  companyName: CompanyOption | '' | null;
}) => {
  const isExistingCompany = useCallback(() => {
    const company = selectedCompany(fields.companyName ?? '');

    if (!company) return false;

    return company.value !== 0;
  }, [fields.companyName]);

  return { isExistingCompany };
};

export default useIsExistingCompany;
